function DropBalon(){
    var dc = document.getElementsByClassName('toast')[0];
    if (dc != null) {
        dc.remove();

    }
};

$(document).on('click','#ballonclose',function () {
    var dc = document.getElementsByClassName('toast')[0];
    if (dc != null) {
        dc.remove();
    }
});
 


$(document).ajaxError(function(e, xhr) {
    if (xhr.status != 200 && xhr.status != 0) {
        // toastr.error('Ошибка '+ xhr.status);
        toastr.warning('</br><button type="button" class="btn btn-warning float-right" onclick="document.location.reload()">Обновить страницу</button>' , 'Что-то пошло не так, попробуйте обновить страницу! '+xhr.status,{timeOut: 999999,positionClass:'toast-bottom-right'});
    //     $("body").append(`
    //     <div class="toast fade show toast-just-text toast-flat toast-error" role="alert" aria-live="assertive" aria-atomic="true" style="position: absolute;top: 9px;right: 9px;z-index: 9999999;background: #ffcccc;

    //     width:20%;height:120px;text-align:center;">
    //       <div class="toast-header">

    //         <strong class="mr-auto">Ошибка ` + xhr.status + `</strong>

    //         <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
    //           <span id="ballonclose" aria-hidden="true">×</span>
    //         </button>
    //       </div>
    //       <div class="toast-body">
    //     <p>Попробуйте позже.</p><div><a href="mailto:support@hserm.ru" style="
    //         text-decoration: underline;text-align:center;
    //         color:  red;
    //     ">Напишите нам</a></div></div>
    //     </div>
    // `);
    //     setTimeout(DropBalon, 10000);
    }
});